import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  renderTrackHorizontalDefault,
  renderTrackVerticalDefault,
  renderThumbHorizontalDefault,
  renderViewDefault,
} from 'react-custom-scrollbars/lib/Scrollbars/defaultRenderElements';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {},
  view: {
    zIndex: 0,
  },
  trackHorizontal: {},
  trackVertical: {},
  thumbHorizontal: {
    backgroundColor: 'rgba(0,0,0,0.5) !important',
  },
  thumbVertical: {
    backgroundColor: 'rgba(0,0,0,0.5) !important',
    // do not attempt to set height it. it does not work properly for some reason
    // the package auto figures height
    //height: '50px !important'
  },
});

class TableScrollbar extends React.Component {
  state = {
    scrollTop: 0,
    scrollHeight: 0,
    clientHeight: 0,
  };

  handleUpdate = values => {
    // no use case.. yet
  };

  render() {
    const { style, children, classes, isVisible, ...props } = this.props;

    if (!isVisible) {
      return children;
    }

    return (
      <Scrollbars
        ref={ref => {
          this.scrollbars = ref;
          if (props.setTableScrollbarRef) {
            props.setTableScrollbarRef(ref);
          }
        }}
        onUpdate={this.handleUpdate}
        // autoHeight
        // autoHeightMin={0}
        // autoHeightMax={499}
        renderTrackHorizontal={props => renderTrackHorizontalDefault({ ...props, className: classes.trackHorizontal })}
        renderTrackVertical={props => renderTrackVerticalDefault({ ...props, className: classes.trackVertical })}
        renderThumbHorizontal={props => renderThumbHorizontalDefault({ ...props, className: classes.thumbHorizontal })}
        renderThumbVertical={props => renderThumbHorizontalDefault({ ...props, className: classes.thumbVertical })}
        renderView={props => renderViewDefault({ ...props, className: classes.view })}
        {...props}>
        {children}
      </Scrollbars>
    );
  }
}

export default styled(TableScrollbar)(styles);
